<template lang="pug">
.footer
  .container
    .row.footer-row
      .col-12.col-xl-6.footer-col
        .footer-title {{ $t('ui.provider') }}
        .footer-content
          ul.provider
            li
              img.img-fluid(src='images/provider/yeebet.png')
            li
              img.img-fluid(src='images/provider/ct855.png')
            li
              img.img-fluid(src='images/provider/sa.png')
            li
              img.img-fluid(src='images/provider/evo.png')
            li
              img.img-fluid(src='images/provider/pretty.png')
            li
              img.img-fluid(src='images/provider/live22.png')
            li
              img.img-fluid(src='images/provider/epic.png')
            li
              img.img-fluid(src='images/provider/uuslots.png')
            li
              img.img-fluid(src='images/provider/horse.png')
            li
              img.img-fluid(src='images/provider/wbet.png')
      .col-7.col-xl-3.footer-col
        .footer-title {{ $t('ui.follow_us') }}
        .footer-content
          ul.social
            li
              a(href='#')
                i.fa-brands.fa-facebook
            li
              a(href='#')
                i.fa-brands.fa-whatsapp
            li
              a(href='#')
                i.fa-brands.fa-telegram
            li
              a(href='#')
                i.fa-brands.fa-instagram
        .footer-title {{ $t('ui.payment_method') }}
        .footer-content
          ul.payment
            li
              img.img-fluid(src='images/payment/ibank.png')
            li
              img.img-fluid(src='images/payment/paytrust.png')
            li
              img.img-fluid(src='images/payment/surepay.png')
      .col-5.col-xl-3.footer-col
        .footer-logo
          //- img.img-fluid(src='images/logo.png')
          | TEST
        .copyright
          .copyright-text {{ $tc('ui.copyright', 1, { "brand" : brand }) }}
          .copyright-text {{ $tc('ui.copyright', 2, { "brand" : brand }) }}
  
</template>

<script>
import config from "@/config";

export default {
  computed: {
    brand() {
      return config.brand;
    }
  }
}
</script>